import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";

import { Tab } from 'semantic-ui-react';
import { useTextResources } from '../../language';
import { PaymentDialog } from '../Payment/paymentDialog';
import CreditPaymentDialog from '../Payment/credit';
import { EntityType } from '../shared/constants';
import { PermissionsActions, UserHasPermission } from '../shared/permissionsActions';

const PaymentTabs = ({ state, setState, dialogRef, hotel, setActiveTab, folio, readOnlyAmount, onIs3dsOpenChange, isPaymentDialogReadOnly  }) => {
    const text = useTextResources();
    const [reservationEntity, setReservationEntity] = useState();

    useEffect(() => {
        if (folio) {
            const reservationEntity = folio.FolioEntities.find(x => x.EntityTypeId === 1)
            if (reservationEntity) {
                setReservationEntity(reservationEntity);
            }
        }
    }, [folio])


    const creditPane = () => <Tab.Pane style={{ flex: 1 }}>
        <CreditPaymentDialog state={state} setState={setState} readOnlyAmount={readOnlyAmount || !UserHasPermission(PermissionsActions.EditReceiptPrice)} />
    </Tab.Pane>

    const paymentPane = () => <Tab.Pane style={{ flex: 1 }}>
        <PaymentDialog
            ref={dialogRef}
            reservation={{
                Id: reservationEntity && reservationEntity.EntityId,
                HotelId: hotel && hotel.Id,
                FolioId: folio && folio.Id,
                entities: folio && folio.FolioEntities,
                GuestId: folio && folio.FolioEntities.find(x => x.EntityTypeId === EntityType.Guest)?.EntityId
            }}
            defaultAction={PaymentDialog.Actions.TakePayment}
            HotelId={hotel && hotel.Id}
            amount={state.amount}
            currencyId={state.selectedPaymentCurrency}
            onSetCurrency={val => setState({
                ...state,
                paymentCurrency: state.ignoreSelectedValueForPaymentCurrency ?
                    state.paymentCurrency : state.selectedPaymentCurrency,
                selectedPaymentCurrency: val
            })}
            onAmountChange={val => setState({
                ...state,
                amount: val
            })}
            onIs3dsOpenChange={onIs3dsOpenChange}
            readOnlyAmount={readOnlyAmount || !UserHasPermission(PermissionsActions.EditReceiptPrice)}
            isReadOnly={isPaymentDialogReadOnly}
        />
    </Tab.Pane>


    return (
        <Tab style={{ height: "100%", display: "flex", flexDirection: "column" }} panes={[
            {
                menuItem: text("ManualPayments"), render: creditPane
            },
            {
                menuItem: text("CreditCards"), render: paymentPane
            }
        ]} onTabChange={(e, { activeIndex }) => setActiveTab(activeIndex)} />
    )
}

PaymentTabs.propTypes = {
    hotel: PropTypes.object,
    state: PropTypes.object,
    dialogRef: PropTypes.object,
    folio: PropTypes.object,
    setState: PropTypes.func,
    setActiveTab: PropTypes.func,
    readOnlyAmount: PropTypes.bool,
    onIs3dsOpenChange: PropTypes.func,
    isPaymentDialogReadOnly: PropTypes.bool,
}

export default PaymentTabs